import { university } from "./brand";
export const INFO_PREFIX = "hcmulaw:info:";
export const privacyKey = INFO_PREFIX + "privacy";
export const channelPages = university.socials.map((s) => ({
  ...s,
  key: INFO_PREFIX + "channel:" + s.label.toLowerCase(),
}));
export function referenceKey(raw: string) {
  try {
    const u = new URL(raw);
    if (
      !["http:", "https:"].includes(u.protocol) ||
      u.username ||
      u.password ||
      u.port ||
      u.href.length > 2048
    )
      return;
    u.protocol = "https:";
    u.hash = "";
    return INFO_PREFIX + "reference:" + encodeURIComponent(u.href);
  } catch {
    return;
  }
}
export const isInformationKey = (raw: string) =>
  raw.length <= 6500 &&
  (raw === privacyKey ||
    channelPages.some((c) => c.key === raw) ||
    (raw.startsWith(INFO_PREFIX + "reference:") &&
      referenceKey(decodeReference(raw) || "") === raw));
export function decodeReference(raw: string) {
  try {
    return raw.startsWith(INFO_PREFIX + "reference:")
      ? decodeURIComponent(raw.slice((INFO_PREFIX + "reference:").length))
      : undefined;
  } catch {
    return;
  }
}
